import React from "react";
import HeaderGuest from "../../components/Header/HeaderGuest";

// A clean, modern FAQ page using only React + TailwindCSS
export default function FaqPage() {
    const faqs = [
        {
            q: "What is the 360° Feedback Process?",
            a: "360-degree feedback is a development tool that provides meaningful and holistic insights into your strengths and areas for improvement. It is NOT used for performance appraisal or salary review. The 360-feedback process collects input from direct reports, peers, and direct managers.",
        },
        {
            q: "How do I log into the platform?",
            a: "You will receive an email with the link to the platform. Click it, enter your email address, enter the provided password and follow the instructions.",
        },
        {
            q: "I didn’t receive my login email. What should I do?",
            a: "Check your spam/junk folder. If it’s not there, contact the support team (ayo@testassessify.com) to resend it.",
        },
        {
            q: "I can’t log in. What should I try first?",
            a: "Try refreshing the page, switching browsers (Chrome recommended), or clearing your cache. If it still fails, contact support (ayo@testassessify.com).",
        },
        {
            q: "The platform is slow or not loading.",
            a: "Check your internet connection. If the issue persists, take a screenshot and report it to support (ayo@testassessify.com).",
        },
        {
            q: "How do I complete my self-assessment?",
            a: (
                <ul className="list-disc pl-5 space-y-1">
                    <li>Select “Self-Review”</li>
                    <li>Click “Take Survey”</li>
                    <li>Complete all questions and click Submit</li>
                </ul>
            ),
        },
        {
            q: "Can I edit my self-assessment after submitting it?",
            a: "No. Once submitted, it cannot be edited. Ensure your responses are final before clicking “Submit.”",
        },
        {
            q: "I have been selected to rate someone else. What do I do?",
            a: "You will receive an email with the link to the platform. Click it, enter your email address, enter the provided password, click on “To Review”, and follow the instructions from there.",
        },
        {
            q: "Is my feedback anonymous?",
            a: "Yes. Individual responses are anonymous and only presented in aggregate.",
        },
        {
            q: "Can I save and continue later?",
            a: "Yes. Click “Save Draft”. You can return at any time before the deadline.",
        },
        {
            q: "How do I know if my raters have completed their feedback?",
            a: "Click on “My Reviewers” to see how many raters have completed the survey. Individual identities are not shown.",
        },
        {
            q: "My survey won’t submit.",
            a: "Ensure all required fields are completed and reload the page. If it continues, escalate to support (ayo@testassessify.com).",
        },
        {
            q: "When will I receive my final report?",
            a: "Reports are usually shared after the rating window closes, and all data has been processed.",
        },
        {
            q: "How long does the 360° feedback process take?",
            a: "The entire feedback process will run from Monday, 9th December 2025, to Friday, 19th December 2025.",
        },
        {
            q: "Will my raters receive reminders?",
            a: "Yes. Automated reminders will be sent to everyone who has a pending survey to fill out, both raters and reviewees.",
        },
        {
            q: "Who do I contact for help?",
            a: (
                <div className="space-y-1">
                    <p>📧 Email: ayo@testassessify.com</p>
                    <p>📞 Phone: +234 916 033 4904</p>
                    <p>⏰ Hours: Mondays–Fridays, 9 am–6pm</p>
                    <p>For General/HR-related questions: Contact your HR representative or programme lead.</p>
                </div>
            ),
        },
    ];

    return (
        <section>
            <header className="py-3 shadow-lg">
                <HeaderGuest />
            </header>
            <div className="min-h-screen bg-gray-50 py-8 mt-5 px-4 flex justify-center">
                <div className="w-full max-w-3xl">
                    <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">360° Feedback FAQs</h1>

                    <div className="space-y-4">
                        {faqs.map((item, index) => (
                            <details
                                key={index}
                                className="group bg-white p-6 rounded-2xl shadow-sm border border-gray-200 hover:shadow-md transition cursor-pointer"
                            >
                                <summary className="flex justify-between items-center font-medium text-gray-800 text-xl w-full cursor-pointer select-none">{item.q}<span className="transition-transform group-open:rotate-180 text-xl text-gray-500">⌄</span></summary>

                                <div className="mt-3 text-gray-600 text-lg leading-relaxed">{item.a}</div>
                            </details>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
